import { icon } from "leaflet";
import React from "react";

export const SearchBarPreviewSide = ({ colors, iconUrl, bubbleColor, companyName, suggestions }) => {
  const { bg, textPrimary, border, inputBg, brand, buttonBg,searchbarBg } = colors;
console.log(iconUrl);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#f0f2f5",
        borderRadius: "12px",
        position: "relative",
        overflow: "hidden",
        border: `1px solid ${border}`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "0 12px 16px",
      }}
    >
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div
          style={{
            border: `2px solid ${bg}`,
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "3.2rem",
            backgroundColor: searchbarBg,
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            borderRadius: "12px",
            padding: "0 8px 0 10px",
            position: "relative",
          }}
        >
          <div
            style={{
              height: "22px",
              width: "22px",
              marginRight: "8px",
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={iconUrl}
              alt="logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              onError={(e) => { e.target.style.display = "none"; }}
            />
          </div>
          <span style={{ flex: 1, fontSize: "12px", color: textPrimary, opacity: 0.4 }}>
            Ask me anything...
          </span>
          <span style={{ padding: "4px", color: colors.textSec, fontSize: "14px", marginRight: "4px" }}>
            ⟳
          </span>
          <span style={{ padding: "4px", color: colors.textSec, fontSize: "13px", marginRight: "2px" }}>
            ➤
          </span>
          <span
            style={{
              background: "none",
              color: textPrimary,
              border: "none",
              width: "24px",
              height: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "22px",
              fontWeight: 500,
              lineHeight: 1,
              flexShrink: 0,
              cursor: "default",
            }}
          >
            ×
          </span>
        </div>

        <div style={{ display: "flex", gap: "8px", marginTop: "8px", overflow: "hidden", flexWrap: "nowrap" }}>
          {(suggestions || ["What services?", "Pricing", "Contact us"]).map((q) => (
            <span
              key={q}
              style={{
                fontSize: "10px",
                padding: "4px 12px",
                borderRadius: "16px",
                background: buttonBg || "rgb(51,51,51)",
                color: "#fff",
                whiteSpace: "nowrap",
                cursor: "default",
              }}
            >
              {q}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};